export const breakPoint = "1024px";